import 'twin.macro'

import { useCreditDecision } from 'hooks/useCreditDecision'
import { useThirdPartyPledgerStatus } from 'hooks/useThirdPartyPledgerStatus'

import AddThirdPartyPledger from './AddThirdPartyPledger'
// import UpgradeOwnPledgeLoanConditions from './UpgradeOwnPledgeLoanConditions'

const UpgradeOwnPledgeLoanConditionsWrapper = () => {
  // Custom hooks
  const { is3rdPartyPledgerApplied } = useCreditDecision()
  const { isPledgerConfirmationFlowDone } = useThirdPartyPledgerStatus()

  return (
    <AddThirdPartyPledger key={'' + is3rdPartyPledgerApplied} isThirdPartyFlowDone={isPledgerConfirmationFlowDone} />
  )

  // return (
  // <div tw='space-y-4'>
  // <UpgradeOwnPledgeLoanConditions />
  // <AddThirdPartyPledger key={'' + is3rdPartyPledgerApplied} isThirdPartyFlowDone={isPledgerConfirmationFlowDone} />
  // </div>
  // )
}

export default UpgradeOwnPledgeLoanConditionsWrapper
